import { Box, Button, Grid, useTheme } from "@mui/material";
import {
	CLIENT_LIST_SCREEN_SLUG,
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../../../common/constants";
import {
	DeleteConfirmationDialog,
	EmptyList,
	EnhancedSnackbar,
	RouterLinkButton,
} from "@websential/cosmic-v20";
import { IResponse, IServerError } from "../../../../models/common";
import { Link, useNavigate } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
	setSelectedActivityLogActions,
	setSelectedDrawerMenu,
	setSelectedStickyNavBar,
} from "../../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { AdminClientRoutesComponent } from "../../../RoleBasedLeftMenu/routes/AdminClientRoutes";
import { ClientRoutesComponent } from "../../../RoleBasedLeftMenu/routes/ClientRoutes";
import { IAppState } from "../../../../store/reducers";
import { IGetListRequest } from "../../../../models";
import { IRoleAssignment } from "../../../../models";
import { PrimeDataGrid } from "../../../PrimeDataGrid";
import { RoleAssignmentService } from "../../../../services/RoleManagementServices/RoleAssignmentService";
import { setSelectedDrawerOptionsMenu } from "../../../../store/actions/drawerMenuOptionsActions";
import { useNavigateToLogout } from "../../../../common/Common";

export interface IRoleAssignmentList { }
const CLIENT_LIST_QUERY_KEY = "roleAssignment-list";

const useRoleAssignment = (
	// clientId: string,
	params: IGetListRequest,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: ["roleAssignment-list", params],
		queryFn: (data) => {

			return RoleAssignmentService.getRoleAssignment(
				// clientId,
				params,
				navigateToLogout
			);
		},
		refetchOnWindowFocus: false,
	});

export const RoleAssignmentList: React.FC<IRoleAssignmentList> = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	const clientIdStore = useSelector((state: IAppState) => state.client.id);
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const navigateToLogout = useNavigateToLogout();
	const { AdminClientRoutes } = AdminClientRoutesComponent();
	const { ClientRoutes } = ClientRoutesComponent();

	// for delete row Purpose
	const queryClient = useQueryClient();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [selectedRowsValues, setSelectedRowsValues] = useState([]);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "roleName",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const { id } = useSelector((state: IAppState) => state.accountant);
	const { isPending, data } = useRoleAssignment(
		// clientIdStore,
		queryParams,
		navigateToLogout
	); //useQuery('accountants-list', AccountantService.getAccountantList, { refetchOnWindowFocus: false });
	const roleAssignmentList: any | null = data;

	const { message, componentState } = useSelector(
		(state: IAppState) => state.viewState
	);

	// const { accountantList } = useSelector(
	//   (state: IAppState) => state.accountant
	// );

	const [openDialog, setDialogOpen] = useState(false);
	const [selectedIds, setSelectedIds] = useState([]);
	const [statusValue, setStatusValue] = useState("");
	const [apiAction, setApiAction] = useState("");
	const [emptyList, setEmptyList] = useState(false);
	const [searchText, setSearchText] = useState({});
	const [zeroRoleAssignment, setzeroRoleAssignment] = useState(true);
	const [roleAssignmentListUpdatedItems, setRoleAssignmentListUpdatedItems] =
		useState<any>(undefined);

	// for delete row
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [roleAssignmentId, setRoleAssignmentId] = useState<any>(0);

	// Bulk Delete
	const [bulkDelete, setBulkDelete] = useState<boolean>(false);
	const [bulkRoleAssignmentId, setBulkRoleAssignmentId] = useState<any>({});
	const [bulkRoleAssignmentDelete, setBulkRoleAssignmentDelete] =
		useState<boolean>(false);

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "roleName",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	const onSearchButtonClicked = () => {
		setQueryParams(searchText);
		setzeroRoleAssignment(false);
	};

	const onRowEditClicked = useCallback((params: IRoleAssignment) => {
		// alert(`Edit row with ID: ${params.row.id} has been clicked!`);
		let path = `/role-management/role-assignment/setup/${params.id}`;
		navigate(path);
	}, []);

	const onCloseHandler = () => {
		setDialogOpen(false);
	};

	const callAction = () => {
		if (apiAction === "delete") {
			alert(`Delete row with ID: ${selectedIds} has been clicked!`);
			// TODO api call for delete
		} else if (apiAction === "updateStatus") {
			alert(`action need to trigger : ${apiAction}`);
			// TODO api call for update status
		}
		setDialogOpen(false);
	};

	// For Delete Row
	const deleteRoleAssignmentField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let delPayload = {
				roleAssignmentId: roleAssignmentId,
				navigateToLogout: navigateToLogout,
			};
			deleteRoleAssignmentById(delPayload);
			setDialogOpen(false);
		}
	};

	const onRowDeleteClicked = useCallback((params: IRoleAssignment) => {
		setDialogOpen(true);
		setSingleDelete(true);
		setApiAction("delete");
		setRoleAssignmentId(params.id);
	}, []);

	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isDeleting, mutate: deleteRoleAssignmentById } = useMutation({
		mutationFn: RoleAssignmentService.delRoleAssignment,

		onSuccess: (res: string | IServerError | IResponse | any) => {

			if (res) {
				// remove the cache of the Year fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: res.message ? res.message : "Something went wrong.",
					severity: res.status === false ? "error" : "success",
				});

				return queryClient.invalidateQueries({
					queryKey: [CLIENT_LIST_QUERY_KEY],
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
		},
		onError: (err) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		setStatusValue(event.target.value as string);
		setApiAction("updateStatus");
		setDialogOpen(true);
	};

	// const onKeyFieldClickHandler = (clickedRow: any) => {
	// dispatch(setSelectedRoleAssignment(clickedRow));
	// dispatch(setSelectedRoleAssignmentName(clickedRow));
	// };

	const onRowMultipleDeleteClicked = (params: any) => {

		let bulkDeletePayload = {
			roleAssignmentIds: { roleAssignmentIds: params },
		};
		setDialogOpen(true);
		setBulkDelete(true);
		setApiAction("delete");
		setBulkRoleAssignmentId(bulkDeletePayload);
		setBulkRoleAssignmentDelete(true);
	};

	const selectionToolbar = useCallback((selectedItems: any) => {
		setSelectedIds(selectedItems);

		if (selectedItems.length) {
			return (
				<Box sx={{ marginTop: theme.spacing(1) }}>
					<Button
						onClick={() => onRowMultipleDeleteClicked(selectedItems)}
						variant="contained"
						color="error"
					>
						Delete
					</Button>
				</Box>
			);
		}
		return (
			<Box sx={{ marginLeft: theme.spacing(1) }}>
				<RouterLinkButton
					to="/role-management/role-assignment/setup"
					text="Add RoleAssignment"
				/>
			</Box>
		);
	}, []);

	const upadtedRoleAssignmentListItems = useMemo(() => {
		return (
			roleAssignmentList &&
			roleAssignmentList.items &&
			roleAssignmentList?.items.map((item: any) => ({
				...item,
				title: (
					<Link
						to={`/role-management/role-assignment/setup/${item.id}`}
						className="no-underline"
						style={{ color: theme.palette.primary.light }}
					>
						{item.title}
					</Link>
				),
			}))
		);
	}, [roleAssignmentList]);



	const expandedLabels = ["Role Management", "Role Assignment"];
	const expandedLabelsForAdmin = ["User Management", "Role Assignment"];
	const expandedRoleAssignmentListOrSetupItem = "List";
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			if (clientIdStore && clientIdStore !== "") {
				let isExpanded = expandedLabelsForAdmin.includes(item.label);
				if (
					parentLabel === "Role Assignment" &&
					item.label === expandedRoleAssignmentListOrSetupItem
				) {
					isExpanded = true;
				}
				const enhancedItem = {
					...item,
					expanded: item.items ? isExpanded : false,
					items: item.items ? enhanceData(item.items, item.label) : undefined,
					path: item.label === expandedRoleAssignmentListOrSetupItem && "/role-management/role-assignment",
				};
				return enhancedItem;
			} else {
				let isExpanded = expandedLabels.includes(item.label);
				if (
					parentLabel === "Role Assignment" &&
					item.label === expandedRoleAssignmentListOrSetupItem
				) {
					isExpanded = true;
				}
				const enhancedItem = {
					...item,
					expanded: item.items ? isExpanded : false,
					items: item.items ? enhanceData(item.items, item.label) : undefined,
					path: item.label === expandedRoleAssignmentListOrSetupItem && "/role-management/role-assignment",
				};
				return enhancedItem;
			}
		});
	};
	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: CLIENT_LIST_SCREEN_SLUG,
				accountantName: "",
				activityType: "activity_type=delete",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: false }));


		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	const image =
		"https://taxslips.blob.core.windows.net/taxslips-public-images-container/empty_roleAssignment_list.png";

	return roleAssignmentList &&
		roleAssignmentList.items &&
		roleAssignmentList.items.length === 0 &&
		zeroRoleAssignment === true ? (
		<EmptyList
			showImage={true}
			imagePath={image}
			heading={`There's nothing! Add RoleAssignment to proceed`}
			content={`You can add RoleAssignment by directly clicking on add RoleAssignment button.`}
			testId={"roleAssignment-empty-list"}
			showAddButton={true}
			addButtonLabel={"Add RoleAssignment"}
			navigateToAdd={"/role-management/role-assignment/setup"}
			showImportButton={false}
			showImportXmlButton={false}
		/>
	) : (
		<>
			<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
				<DeleteConfirmationDialog
					open={openDialog}
					deleteActionHandler={deleteRoleAssignmentField}
					cancelActionHandler={onCloseHandler}
					testId="tax-profile-tab-confirmation-dialog"
				/>
				<PrimeDataGrid
					columns={roleAssignmentList ? roleAssignmentList.headerColumns : []}
					rows={
						roleAssignmentList && upadtedRoleAssignmentListItems
							? upadtedRoleAssignmentListItems
							: []
					}
					showIndexColumn={true}
					showChecboxColumn={isAdminUser === 400 ? true : false}
					showSettingColumn={true}
					onRowEditClicked={onRowEditClicked}
					onRowDeleteClicked={onRowDeleteClicked}
					isLoading={isPending || isDeleting}
					onSnackbarMessageData={(value: any) => setSnackbarData(value)}
					totalRecords={
						roleAssignmentList && roleAssignmentList.total ? roleAssignmentList.total : 0
					}
					initialPageSize={INITIAL_PAGE_SIZE}
					rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
					onRequestParamsChange={onRequestParamsChange}
					selectionToolbar={selectionToolbar}
					selectedRowsValues={(value: any) => setSelectedRowsValues(value)}
					searchFieldPlaceholder={"Search by RoleAssignment Name..."}
					changeLoginForGetEmptyItemsBySearchQuery={(value: any) =>
						setzeroRoleAssignment(value)
					}
				/>
			</Grid>
			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={`snackbar`}
				open={snackbarData.open}
			/>
		</>
	);
};
